import axios from 'axios';
import React from 'react';
import { Auth0Provider, Auth0ProviderOptions } from '@auth0/auth0-react';

import { Auth0Adapter } from '../authentication/adapter';
import { addImpersonationInterceptor } from '../authentication';

export const CONFIG_KEY = 'NEWRON_PLATFORM_CONFIG';
export const CALLBACK_URL = `${window.location.origin}/callback`;

function Root() {
  const urlParams = new URLSearchParams(window.location.search);
  const campaign = urlParams.get('utm_campaign');
  const auth0Options: Auth0ProviderOptions = {
    domain: window[CONFIG_KEY]?.AUTH0_DOMAIN || '',
    clientId: window[CONFIG_KEY]?.AUTH0_CLIENT_ID || '',
    audience: window[CONFIG_KEY]?.AUTH0_AUDIENCE || '',
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
    scope: 'openid profile',
    redirectUri: CALLBACK_URL,
    ...(campaign ? { utm_campaign: campaign } : {}),
  };

  addImpersonationInterceptor(axios, { ignoreUrls: ['ui-logging'] });

  return (
    <Auth0Provider {...auth0Options}>
      <Auth0Adapter />
    </Auth0Provider>
  );
}

export { Root };
